import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import CboGrupo from "./CboGrupo";
import CboEmpresa from "./CboEmpresa";

const VarAlumnos = (props) => {


  const [codigo, setCodigo] = useState("")
  const [nombre, setNombre] = useState("")
  const [descrip, setDescrip] = useState("")
  //   const [grupo, setGrupo] = useState("")    reemplazado por props.grupo
  const [empresa, setEmpresa] = useState("")
  const [varalum, setVaralum] = useState([])



  const [activo, setActivo] = useState(false)
  const [noteditable, setNotEditable] = useState(true)

  // ventana de búsqueda
  const [vermodal, setVermodal] = useState(false)


  // ventana de confirmación
  const [vermodalconf, setVermodalConf] = useState(false)

  // toast
  const [showToast, setShowToast] = useState(false);
  const [textoToast, setTextoToast] = useState("");

  /*
     async function    handleOnChangeActivo(e){
      setSearchActivo(!searchactivo); 
      setSearchMessage("");
   }
   
  */



  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grupo = props.grupo;
    consulta.empresa = 1;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/var/allalumnos`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data;
        console.log(json3.data);
        setVaralum(json3.data);
        // si hay datos, cargar en la ficha el primero
        if (json3.data.length) {

          setNombre(json3.data[0].Val_Nombre);
          setDescrip(json3.data[0].Val_Descrip);
        }
        console.log("Vars Alumnos", json3);

      })


  }, []);




  const handleGoVarAlu = (index, event) => {
    setNombre(varalum[index].Val_Nombre);
    setDescrip(varalum[index].Val_Descrip);

  }


  const handleGrupoChange = (event) => {
    // setGrupo(event.target.value);
  };

  const handleEmpresaChange = (event) => {
    setEmpresa(event.target.value);
  };


  /* Save */
  async function handleSave(e) {
    // validar ???

    // llamo a la grabación del registro de alumno

    let unAlumno = new Object();
    unAlumno.codigo = codigo;
    unAlumno.nombre = nombre;

    //        addAlumno(unAlumno);

    var url;
    var json;
    e.preventDefault()
    try {
      setNotEditable(true);
      json = JSON.stringify(unAlumno);
      console.log(json);
      if (codigo) {
        url = `${process.env.REACT_APP_API_URL}/alu/update`;
      }
      else {
        url = `${process.env.REACT_APP_API_URL}/alu/addnew`;
      }


      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credential: 'include',
        body: json,

      };

      fetch(url, options)
        .then(response => response.json())
        .then(data => {

          json = data.data;
          console.log(json);
          // setNombre (json.nombre);
          // setApellido (json.apellido);            
          // setActivo (json.actvo);

          /* toast */
          setTextoToast("Alumno guardado");
          setShowToast(true);


        })
    } catch (error) {
      console.log(error);

    }



  }

  async function handleNew(e) {
    setCodigo("");
    setNombre("");

    setNotEditable(false);
  }


  async function handleCancel(e) {
    setCodigo("");
    setNombre("");

    setNotEditable(true);

  }

  /* Editar */
  async function handleEdit(e) {
    e.preventDefault()
    try {

      setNotEditable(false);
    } catch (error) {
      console.log(error);

    }

  }

  return (
    <div >




      <div className="container-fluid">
        <h3>Variables de Alumnos</h3>
        <div className="row">


          <div className="col-xs-12 col-lg-10 col-sm-10 col-md-10">
            <form>

              <div className="row">

                <CboGrupo
                  selectedValue={props.grupo}
                  onChange={handleGrupoChange}
                  disabled={true}
                  grusu={props.grusu}
                />

                <CboEmpresa
                  selectedValue={empresa}
                  onChange={handleEmpresaChange}
                  disabled={true}
                  grupo={props.grupo}
                  grusu={props.grusu}
                />

                <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4">

                  <div className="form-group">

                    <label className="l">
                      Nombre
                    </label>

                    <input
                      type="text"
                      className="input-select"
                      placeholder="Nombre de variable"
                      onChange={e => setNombre(e.target.value)}
                      value={nombre}
                      disabled={noteditable}
                    />

                  </div>

                </div>

                <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4">

                  <div className="form-group">

                    <label className="l">
                      Descripción
                    </label>

                    <input
                      classNamePrefix="miSelect"
                      type="text"
                      className="input-select"
                      placeholder="Descripción"
                      onChange={e => setDescrip(e.target.value)}
                      value={descrip}
                      disabled={noteditable}
                    />

                  </div>

                </div>

              </div>

            </form>


            <div className="acciones-botones">

              <button
                type="button"
                className="filtrar"
                id="clear"
                onClick={handleNew}
                disabled={!noteditable}
              >
                Nuevo
              </button>

              <button
                type="button"
                className="filtrar"
                id="edit"
                onClick={handleEdit}
                disabled={!noteditable}
              >
                Editar
              </button>

              <button
                type="button"
                className="filtrar"
                id="grabar"
                onClick={handleSave}
                disabled={noteditable}
              >
                Guardar
              </button>

              <button
                type="button"
                className="filtrar"
                id="cancelar"
                onClick={handleCancel}
                disabled={noteditable}
              >
                Cancelar
              </button>

            </div>
          </div>

        </div>


        <table className="table table-striped table-primary table-hover">
          <thead>
            <tr className="row" >
              <th key={'_hnomb'} className="col-1" >
                Nombre
              </th>
              <th key={'_hdescr'} className="col-3" >
                Descripción
              </th>
            </tr>


          </thead>
          <tbody>
            {

              varalum.map((unolista, index) => (
                <tr key={index + '_row'} className="row" onClick={(event) => handleGoVarAlu(index, event)}>
                  <td key={index + '_nomb'} className="col-1" >
                    {unolista.Val_Nombre}
                  </td>
                  <td key={index + '_descr'} className="col-3" >
                    {unolista.Val_Descrip}
                  </td>

                </tr>
              )
              )
            }

          </tbody>
        </table>

      </div>

      <ToastContainer position="bottom-end">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>

          <Toast.Body>{textoToast}</Toast.Body>
        </Toast>
      </ToastContainer>










      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="liveToastmsg" className="toast" role="alert" aria-live="assertive" aria-atomic="true">

          <div className="toast-body">

          </div>
        </div>
      </div>













    </div>
  );
};

export default VarAlumnos;

